import React from 'react'
import classNames from 'classnames'
import { WemoloTypography } from '../../../components/Wemolo'
import { DETECTION_EXPLORER_TEXT, isFieldUnset } from '../config'
import styles from './Chips.module.css'

// Accepts the raw API direction string (IN/OUT/TURN/INV). INV is the catch-all, so there's no unset case.
const directionToneClass = (direction: string): string => {
    if (direction === 'OUT') return styles.directionChipOut
    if (direction === 'TURN') return styles.directionChipTurn
    if (direction === 'INV') return styles.directionChipInv
    return ''
}

export const DirectionChip: React.FC<{ direction: string }> = ({ direction }) => (
    <span className={classNames(styles.directionChip, directionToneClass(direction))}>
        <WemoloTypography variant="label-small" tag="span" className={styles.directionChipLabel}>
            {direction}
        </WemoloTypography>
    </span>
)

export const VehicleTypeChip: React.FC<{ vehicleType: string }> = ({ vehicleType }) => (
    <span className={styles.vehicleTypeChip}>
        <WemoloTypography variant="label-small" tag="span">
            {isFieldUnset(vehicleType) ? DETECTION_EXPLORER_TEXT.notSet : vehicleType}
        </WemoloTypography>
    </span>
)
